<template>
  <section class="app-solicitacao">
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
      >
        <v-flex
          lg12
          sm12
          xs12
        >
          <v-card
            outlined
            class="app-card"
          >
            <v-card-title class="app-card-title">
              Painel da Ouvidoria
            </v-card-title>
            <v-card-text class="app-card-content">
              <p>
                Com o objetivo de aperfeiçoar a atuação da Agência Reguladora do Estado do Ceará (Arce) junto aos prestadores de serviços e, por consequência, melhorar a qualidade dos serviços regulados, a Ouvidoria desenvolveu, com apoio do setor de tecnologia da informação, um painel de informações com os dados de solicitações. Citada ferramenta foi elaborada através da utilização da plataforma Data Studio, do Google, tendo como base os dados registrados no Sistema de Ouvidoria da Arce – SOA. A estruturação de gráficos e indicadores no painel se traduz como um importante instrumento para a eficácia e a transparência das atividades.
              </p>

              <p>Acesse, logo abaixo, os dados consolidados das quatro áreas de atuação da Agência: saneamento básico, transporte rodoviário intermunicipal, energia elétrica e gás natural canalizado:</p>
              <iframe
                width="100%"
                height="450"
                :src="srcIframe"
                frameborder="0"
                style="border:0"
                allowfullscreen
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PainelOuvidoria",

  data: () => ({
    srcIframe: 'https://datastudio.google.com/embed/reporting/d9f82781-31d1-45a2-a31c-22fc26040100/page/p_679214r6rc'
  })
}
</script>
